import type { CSSProperties } from 'react';

// The roster's legend, attached under the timeline as the operator's design draws it (2026-10-26):
// each swatch drawn with the same attributes the roster's bars carry, so the legend cannot drift
// from the bars. Shift colours are the operator's of 2026-10-17; a task is a progress bar; the
// flags mark a problem on a shift.

type Swatch = {
  label: string;
  attrs: Record<string, string>;
  /** A task bar, this full. */
  task?: number;
};

const on = 'true';

const GROUPS: Array<{ title: string; swatches: Swatch[] }> = [
  {
    title: 'Tasks',
    swatches: [
      { label: 'Part-filled', attrs: {}, task: 50 },
      { label: 'Covered', attrs: { 'data-covered': on }, task: 100 },
      { label: 'Done', attrs: { 'data-done': on }, task: 100 },
    ],
  },
  {
    title: 'Shifts',
    swatches: [
      { label: 'Draft', attrs: { 'data-state': 'draft' } },
      { label: 'Published', attrs: { 'data-state': 'published' } },
      { label: 'Offered', attrs: { 'data-state': 'offered' } },
      {
        label: 'Accepted, office to confirm',
        attrs: { 'data-state': 'accepted', 'data-unconfirmed': on },
      },
      {
        label: 'Due to confirm',
        attrs: { 'data-state': 'accepted', 'data-unconfirmed': on, 'data-due': on },
      },
      { label: 'Confirmed', attrs: { 'data-state': 'accepted', 'data-confirmed': on } },
      { label: 'Declined', attrs: { 'data-state': 'declined' } },
      { label: 'Carries no task', attrs: { 'data-state': 'accepted', 'data-untasked': on } },
      { label: 'Offer of places', attrs: { 'data-offer': on } },
    ],
  },
  {
    title: 'Flags',
    swatches: [
      { label: 'Clashes', attrs: { 'data-clash': on } },
      { label: 'Needs a ticket', attrs: { 'data-gaps': on } },
      { label: 'Job cancelled', attrs: { 'data-flagged': on } },
    ],
  },
];

export function RosterKey() {
  return (
    <div className="roster-legend" role="list" aria-label="Key">
      {GROUPS.map((g, i) => (
        <span key={g.title} className="contents">
          {i > 0 ? <span className="h-3.5 w-px bg-divider" aria-hidden="true" /> : null}
          <span className="roster-legend-title" aria-hidden="true">
            {g.title}
          </span>
          {g.swatches.map((s) => (
            <span key={s.label} role="listitem" className="roster-legend-item">
              <span
                className={`roster-bar ${s.task !== undefined ? 'task-bar' : ''}`}
                style={
                  s.task !== undefined ? ({ '--fill': `${s.task}%` } as CSSProperties) : undefined
                }
                {...s.attrs}
              >
                {s.task !== undefined ? <span className="task-fill" /> : null}
              </span>
              {s.label}
            </span>
          ))}
        </span>
      ))}
    </div>
  );
}
